/* global gon */
/* global Stripe */
import { Controller } from "stimulus";

import loadScript from "~/lib/asyncScriptLoader";

const stripeJSUri = "https://js.stripe.com/v3/";

export default class extends Controller {
  static targets = [
    "cardElement",
    "cardErrors",
    "form",
    "cardToken",
    "cardType",
    "cardLast4",
  ];

  connect() {
    if (!this.scriptPromise) {
      this.scriptPromise = loadScript(stripeJSUri);
    }
    this.initializeStripe();
  }

  async initializeStripe() {
    try {
      await this.scriptPromise;

      if (!this.stripe) {
        this.stripe = Stripe(gon.stripe.publishableKey);
        const elements = this.stripe.elements();

        const classes = {
          base: "form-control stripe-card",
        };

        const style = {
          base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#aab7c4",
            },
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        };

        this.card = elements.create("card", {
          classes,
          style,
        });
        this.card.mount(this.cardElementTarget);

        this.card.addEventListener("change", (event) => {
          const displayError = this.cardErrorsTarget;
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = "";
          }
        });

        // Handle form submission
        const form = this.formTarget;
        form.addEventListener("submit", this.handleStripeSubmit);
      }
    } catch (error) {
      console.error("Error initializing Stripe:", error);
    }
  }

  handleStripeSubmit = (event) => {
    event.preventDefault();

    this.stripe.createToken(this.card).then((result) => {
      if (result.error) {
        const errorElement = this.cardErrorsTarget;
        errorElement.textContent = result.error.message;
      } else {
        this.stripeTokenHandler(result.token);
      }
    });
  };

  stripeTokenHandler({ id, card }) {
    this.cardTokenTarget.value = id;
    this.cardTypeTarget.value = card.brand;
    this.cardLast4Target.value = card.last4;

    // Submit the form
    this.formTarget.submit();
  }

  destroyStripe() {
    this.formTarget.removeEventListener("submit", this.handleStripeSubmit);
    if (this.card) {
      this.card.destroy();
      this.card = null;
    }
    this.stripe = null;
  }

  hideCardErrors() {
    if (this.hasCardErrorsTarget) {
      this.cardErrorsTarget.classList.add("hidden");
    }
  }

  showCardErrors() {
    if (this.hasCardErrorsTarget) {
      this.cardErrorsTarget.classList.remove("hidden");
    }
  }
}
